import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { InputSwitch } from "primereact/inputswitch";
import { RadioButton } from "primereact/radiobutton";
import { useRef, useState } from "react";
import ReactPlayer from "react-player";
import { Card } from "primereact/card";
import { Image } from "primereact/image";
import { Tooltip } from "primereact/tooltip";
import { OverlayPanel } from "primereact/overlaypanel";
import AddTransitionSlideModel from "./AddTransitionSlideModel";
import { Dropdown } from "primereact/dropdown";
import { transitionLengthOptions } from "../../../../../../utils/constants";
import noneEffectImg from "../../../../../../assets/images/noneeffect.jpg";
import fadeOutEffectImg from "../../../../../../assets/images/fadeouteffect.jpg";
import fadeInEffectImg from "../../../../../../assets/images/fadeineffect.jpg";
import blackEffectImg from "../../../../../../assets/images/blackeffect.jpg";
import { InputTextarea } from "primereact/inputtextarea";

const PresentationView = ({
  isSlideChecked,
  idx,
  handleSlideCheck,
  slideCheckedValue,
  slideName,
  subTitleForTheSlide,
  handleSubTitleForTheSlide,
}) => {
  const [
    isAddTransitionSlideModelVisible,
    setIsAddTransitionSlideModelVisible,
  ] = useState(false);
  const [selectedPresentationVideoIndex, setSelectedPresentationVideoIndex] =
    useState(null);
  const [faceBlur, setFaceBlur] = useState("without-face-blur");
  const [selectedPresentationVideo, setSelectedPresentationVideo] = useState(0);
  const [transitionEffect, setTransitionEffect] = useState("none");
  const [transitionLength, setTransitionLength] = useState(1);
  const [applyToAllSlides, setApplyToAllSlides] = useState(false);
  const [showTextPreview, setShowTextPreview] = useState(false);
  const [textPreviewValue, setTextPreviewValue] = useState("Text Preview");
  const playerRef = useRef(null);
  const addTransitionOp = useRef(null);
  const [screenshots, setScreenshots] = useState([
    {
      id: 1,
      url: "https://via.placeholder.com/200x150?text=Screenshot+1",
      timestamp: "00:15",
      title: "Scene 1",
    },
    {
      id: 2,
      url: "https://via.placeholder.com/200x150?text=Screenshot+2",
      timestamp: "00:45",
      title: "Scene 2",
    },
    {
      id: 3,
      url: "https://via.placeholder.com/200x150?text=Screenshot+3",
      timestamp: "01:20",
      title: "Scene 3",
    },
    {
      id: 4,
      url: "https://via.placeholder.com/200x150?text=Screenshot+4",
      timestamp: "02:10",
      title: "Scene 4",
    },
    {
      id: 5,
      url: "https://via.placeholder.com/200x150?text=Screenshot+5",
      timestamp: "03:05",
      title: "Scene 5",
    },
    {
      id: 6,
      url: "https://via.placeholder.com/200x150?text=Screenshot+6",
      timestamp: "04:00",
      title: "Scene 6",
    },
  ]);

  const handleShuffleSlider = (index, direction) => {
    if (direction === "forward" && index < screenshots.length - 1) {
      const newScreenshots = [...screenshots];
      [newScreenshots[index], newScreenshots[index + 1]] = [
        newScreenshots[index + 1],
        newScreenshots[index],
      ];
      setScreenshots(newScreenshots);
    } else if (direction === "backward" && index > 0) {
      const newScreenshots = [...screenshots];
      [newScreenshots[index], newScreenshots[index - 1]] = [
        newScreenshots[index - 1],
        newScreenshots[index],
      ];
      setScreenshots(newScreenshots);
    }
  };

  return (
    <div className="presentation-view p-3 mt-3">
      <div className="container">
        <div className="d-flex align-items-center gap-2">
          <div className="d-flex align-items-center gap-2">
            <div className="d-flex align-items-center gap-2">
              <Checkbox
                inputId={`slide-checked-${idx}`}
                checked={isSlideChecked}
                onChange={(e) => handleSlideCheck(e.value)}
                value={slideCheckedValue}
              />
              <label
                htmlFor={`slide-checked-${idx}`}
                className="ms-2"
                title={slideName}
              >
                {slideName}
              </label>
            </div>
            <div className="cursor-pointer d-flex align-items-center ms-3">
              <span>
                <i className="pi pi-pencil" />
              </span>
              <Button className="px-2 fs-14" link>
                EDIT
              </Button>
            </div>
          </div>

          <div className="d-flex align-items-center gap-2 ms-auto">
            <div className="cursor-pointer d-flex align-items-center">
              <span>
                <i className="pi pi-pencil" />
              </span>
              <Button className="px-2 fs-14" link>
                SHARE
              </Button>
            </div>
            <div className="cursor-pointer d-flex align-items-center ms-3 justify-content-center">
              <span>
                <i className="pi pi-share-alt" />
              </span>
              <Button
                className="px-2 fs-14"
                link
                onClick={(e) => addTransitionOp.current.toggle(e)}
              >
                ADD TRANSITION
              </Button>

              {/* transition options overlay panel */}
              <OverlayPanel
                ref={addTransitionOp}
                className="p-2"
                style={{ width: "220px" }}
              >
                <div className="transition-panel">
                  {/* Transition Effect Section */}
                  <div className="mb-4">
                    <h6 className="fw-600 mb-3">Transition Effect</h6>
                    <div className="d-flex align-items-center gap-2 flex-wrap">
                      <div className="d-flex align-items-center">
                        <RadioButton
                          inputId="transition-none"
                          name="transitionEffect"
                          value="none"
                          checked={transitionEffect === "none"}
                          onChange={(e) => setTransitionEffect(e.value)}
                        />
                        <label
                          htmlFor="transition-none"
                          className="ps-2 mb-0 d-flex align-items-center flex-column"
                        >
                          <img src={noneEffectImg} />
                          <span>None</span>
                        </label>
                      </div>
                      <div className="d-flex align-items-center">
                        <RadioButton
                          inputId="transition-fadeout"
                          name="transitionEffect"
                          value="fadeOut"
                          checked={transitionEffect === "fadeOut"}
                          onChange={(e) => setTransitionEffect(e.value)}
                        />
                        <label
                          htmlFor="transition-fadeout"
                          className="ps-2 mb-0 d-flex align-items-center flex-column"
                        >
                          <img src={fadeOutEffectImg} />
                          <span>Fade Out</span>
                        </label>
                      </div>
                      <div className="d-flex align-items-center">
                        <RadioButton
                          inputId="transition-fadein"
                          name="transitionEffect"
                          value="fadeIn"
                          checked={transitionEffect === "fadeIn"}
                          onChange={(e) => setTransitionEffect(e.value)}
                        />
                        <label
                          htmlFor="transition-fadein"
                          className="ps-2 mb-0"
                        >
                          <img src={fadeInEffectImg} />
                          <br />
                          Fade In
                        </label>
                      </div>
                      <div className="d-flex align-items-center">
                        <RadioButton
                          inputId="transition-black"
                          name="transitionEffect"
                          value="black"
                          checked={transitionEffect === "black"}
                          onChange={(e) => setTransitionEffect(e.value)}
                        />
                        <label htmlFor="transition-black" className="ps-2 mb-0">
                          <img src={blackEffectImg} />
                          <br />
                          Black
                        </label>
                      </div>
                    </div>
                  </div>

                  {/* Transition Length Section */}
                  <div className="mb-4">
                    <h6 className="fw-600 mb-2">Transition Length</h6>
                    <p className="text-muted small mb-2">(in seconds)</p>
                    <Dropdown
                      value={transitionLength}
                      onChange={(e) => {
                        setTransitionLength(e.value);
                      }}
                      options={transitionLengthOptions}
                      optionLabel="name"
                      placeholder="Select transition length"
                      className="m-color w-100 inputField"
                    />
                  </div>

                  {/* Apply to All Slides Section */}
                  <div className="mb-4">
                    <div className="d-flex align-items-center">
                      <Checkbox
                        inputId="apply-to-all-slides"
                        checked={applyToAllSlides}
                        onChange={(e) => setApplyToAllSlides(e.checked)}
                      />
                      <label
                        htmlFor="apply-to-all-slides"
                        className="ps-2 mb-0"
                      >
                        Apply to All Slides
                      </label>
                    </div>
                  </div>

                  {/* Action Buttons */}
                  <div className="d-flex gap-1 justify-content-end border-top pt-1">
                    <Button
                      icon="pi pi-check"
                      className="p-button-rounded p-button-text py-0"
                      onClick={() => {
                        // Handle apply transition logic here
                        console.log({
                          transitionEffect,
                          transitionLength,
                          applyToAllSlides,
                        });
                        addTransitionOp.current.hide();
                      }}
                    />
                    <Button
                      icon="pi pi-times"
                      className="p-button-rounded text-dark p-button-text py-0"
                      onClick={() => addTransitionOp.current.hide()}
                    />
                  </div>
                </div>
              </OverlayPanel>
            </div>
            <div className="cursor-pointer d-flex align-items-center ms-3">
              <span>
                <i className="pi pi-clone" />
              </span>
              <Button className="px-2 fs-14" link>
                CLONE
              </Button>
            </div>
            <div className="cursor-pointer d-flex align-items-center ms-3">
              <span>
                <i className="pi pi-trash" />
              </span>
              <Button className="px-2 fs-14" link>
                DELETE
              </Button>
            </div>
          </div>
        </div>

        <div className="cursor-pointer d-flex align-items-center">
          <span>
            <i className="pi pi-plus" />
          </span>
          <Button className="px-2 fs-14" link>
            ADD DESCRIPTION
          </Button>
        </div>

        <div className="my-3">
          <div className="position-relative">
            <ReactPlayer
              ref={playerRef}
              className="w-100"
              style={{ height: "600px" }}
              src={"https://www.youtube.com/watch?v=LXb3EKWsInQ"}
              controls
              onTimeUpdate={(e) => console.log(e.target.value)}
            />

            {showTextPreview ? (
              <div className="caption-preview-textarea">
                <div className="d-flex justify-content-end">
                  <Button
                    icon="pi pi-times"
                    className="p-1"
                    onClick={() => setShowTextPreview(false)}
                  />
                </div>
                <InputTextarea
                  value={textPreviewValue}
                  className="preview-textarea cursor-pointer w-100"
                  cols={2}
                  rows={1}
                  onChange={(e) => setTextPreviewValue(e.target.value)}
                />
                <div className="d-flex justify-content-end">
                  <Button
                    icon="pi pi-times"
                    className="p-1 bg-success border-success"
                    onClick={() => setShowTextPreview(false)}
                  />
                  <Button
                    icon="pi pi-check"
                    className="p-1 bg-success border-success"
                    onClick={() => setShowTextPreview(false)}
                  />
                </div>
              </div>
            ) : (
              <div className="caption-preview">
                <div
                  className="preview-text cursor-pointer"
                  onClick={() => setShowTextPreview(true)}
                >
                  <span>Text preview</span>
                </div>
              </div>
            )}
          </div>

          {/* Screenshots Section */}
          <div className="mt-5 pt-4 border-top">
            <div
              className="d-flex align-items-center g-3"
              style={{ maxWidth: "100%", overflowX: "auto" }}
            >
              {screenshots?.map((s, i) => (
                <div
                  key={i}
                  className="col-sm-6 col-md-4 col-lg-3 cursor-pointer slider-item"
                  style={{
                    opacity: selectedPresentationVideo === i ? 1 : 0.6,
                  }}
                  onClick={() => setSelectedPresentationVideo(i)}
                >
                  <Tooltip target={`.add-transition-slide-${i}`} />
                  <div className="d-flex align-items-center">
                    {i === 0 && (
                      <div
                        className={`cursor-pointer add-transition-btn fs-16 d-flex align-items-center justify-content-center add-transition-slide-${i} me-1`}
                        data-pr-tooltip="Add Transition Slide"
                        data-pr-position="top"
                        data-pr-at="center top-6"
                        onClick={() => {
                          setIsAddTransitionSlideModelVisible(true);
                          setSelectedPresentationVideoIndex(i);
                        }}
                      >
                        +
                      </div>
                    )}
                    <div className="card-body p-0">
                      <div
                        className="position-relative"
                        style={{
                          backgroundColor: "#f8f9fa",
                          border: "1px solid #dee2e6",
                          height: "120px",
                        }}
                      >
                        {/* Play icon overlay */}
                        <i
                          className="pi pi-play-circle"
                          style={{
                            fontSize: "2.5rem",
                            color: "#007bff",
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                          }}
                        ></i>
                        <div
                          className="d-flex align-items-center justify-content-center cursor-pointer"
                          style={{
                            position: "absolute",
                            top: "42%",
                            right: "0",
                            transform: "translate(0%, 42%)",
                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                            padding: "4px",
                            height: "18px",
                            width: "18px",
                            borderRadius: "4px",
                          }}
                          onClick={() => handleShuffleSlider(i, "forward")}
                        >
                          <i className="pi pi-play fs-12" />
                        </div>
                        {i !== 0 && (
                          <div
                            className="d-flex align-items-center justify-content-center cursor-pointer"
                            style={{
                              position: "absolute",
                              top: "55%",
                              right: "0",
                              transform: "translate(0%, 55%)",
                              backgroundColor: "rgba(0, 0, 0, 0.5)",
                              padding: "4px",
                              height: "18px",
                              width: "18px",
                              borderRadius: "4px",
                            }}
                            onClick={() => handleShuffleSlider(i, "backward")}
                          >
                            <i
                              className="pi pi-play fs-12"
                              style={{
                                transform: "rotate(-180deg)",
                              }}
                            />
                          </div>
                        )}
                      </div>
                      <div className="text-truncate d-flex align-items-center justify-content-between">
                        <div>{s.title}</div>
                        <div>
                          <Button className="px-2 py-1 fs-12 bg-white" link>
                            <i className="pi pi-plus fs-12 fw-600 me-1" />
                            Text
                          </Button>
                        </div>
                        <div className="d-flex align-items-center justify-content-end gap-2">
                          <i className="pi pi-pencil fs-12"></i>
                          <i className="pi pi-trash fs-12"></i>
                        </div>
                      </div>
                    </div>
                    <div
                      className={`cursor-pointer add-transition-btn fs-16 d-flex align-items-center justify-content-center add-transition-slide-${i} mx-1`}
                      data-pr-tooltip="Add Transition Slide"
                      data-pr-position="top"
                      data-pr-at="center top-6"
                      onClick={() => {
                        setIsAddTransitionSlideModelVisible(true);
                        setSelectedPresentationVideoIndex(i);
                      }}
                    >
                      +
                    </div>
                  </div>
                  <div className="p-3">
                    <span>
                      <i className="pi pi-user fs-14" />
                    </span>
                    <span className="ms-3 text-dark fs-14">1023</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="d-flex align-items-center gap-2">
          <div className="d-flex align-items-center gap-3">
            <div className="d-flex align-items-center">
              <RadioButton
                inputId={"without-face-blur"}
                name="withoutFace-blur"
                value={"without-face-blur"}
                checked={faceBlur === "without-face-blur"}
                onChange={(e) => {
                  setFaceBlur(e.value);
                }}
              />
              <label htmlFor={"without-face-blur"} className="ps-2">
                {"WITHOUT FACE BLURRED"}
              </label>
            </div>

            <div className="d-flex align-items-center">
              <RadioButton
                inputId={"with-face-blur"}
                name="withFace-blur"
                value={"with-face-blur"}
                checked={faceBlur === "with-face-blur"}
                onChange={(e) => {
                  setFaceBlur(e.value);
                }}
              />
              <label htmlFor={"with-face-blur"} className="ps-2">
                {"WITH FACE BLURRED"}
              </label>
            </div>
          </div>
          <div className="d-flex align-items-center gap-2 ms-auto">
            <span className="text-muted small">
              <span className="me-2">Subtitle for the slides</span>{" "}
              {subTitleForTheSlide ? "On" : "Off"}
            </span>
            <InputSwitch
              checked={subTitleForTheSlide}
              style={{
                height: "25px",
              }}
              onChange={(e) => {
                handleSubTitleForTheSlide(e.value);
              }}
              className="custom-smooth-switch"
            />
          </div>
        </div>
      </div>

      {isAddTransitionSlideModelVisible && (
        <AddTransitionSlideModel
          isAddTransitionSlideModelVisible={isAddTransitionSlideModelVisible}
          setIsAddTransitionSlideModelVisible={
            setIsAddTransitionSlideModelVisible
          }
          selectedPresentationVideoIndex={selectedPresentationVideoIndex}
        />
      )}
    </div>
  );
};

export default PresentationView;
